import { IExtendedContext } from '../../../../types/extendedContext';
import { updateDepositAccountPayment } from '../../../../../shared/ServicePickerWidget/actions/depositAccount';
import {
  checkPaymentStatus,
  EPaymentStatusCheckType,
  processChangingCheckPaymentStatus,
} from '../../../../../shared/ServicePickerWidget';

import { ICheckPaymentStatusHandlerParams } from './types';
import { EPaymentStatus } from '../../../../../shared/ServicePickerWidget/services/billingPayments';
import { changePlacingType } from '../../../../../shared/ServicePickerWidget/actions/publishTerms';
import { EPaymentType } from '../../../../../shared/ServicePickerWidget/reducers/v2';

export const checkPaymentStatusHandler =
  (context: IExtendedContext) =>
  async (params: ICheckPaymentStatusHandlerParams): Promise<EPaymentStatus> => {
    const { paymentId, type, provider } = params;

    if (!paymentId) {
      return Promise.resolve(EPaymentStatus.Canceled);
    }

    if (type === EPaymentStatusCheckType.Package) {
      context.store.dispatch(changePlacingType(null));
    }

    context.store.dispatch(
      updateDepositAccountPayment({
        paymentId,
        provider,
        type: type === EPaymentStatusCheckType.Balance ? EPaymentType.Balance : EPaymentType.Package,
      }),
    );
    const result = await context.store.dispatch(
      checkPaymentStatus({ paymentId, provider, onChangePaymentStatus: processChangingCheckPaymentStatus(type) }),
    );

    return result;
  };
